import { createContext, type CSSProperties } from 'react';

// Context object for page theme; kept in separate module to satisfy fast refresh
export const PageThemeContext = createContext<CSSProperties>({});
